<script lang="ts">
    import { getDBEntry } from "../api"
    import Loader from "../lib/components/Loader.svelte"
    import ManualProtocol from "../lib/taskSteps/widgets/ManualProtocol.svelte"
    import { spaNavigate } from "../lib/actions"

    export let orderId: string
    export let taskId: string

    let task: TaskOilSpillRemoval | TaskTowing = null
    let manualTask: TaskOilSpillRemoval | TaskTowing = null

    async function loadData() {
        // @ts-ignore
        const fetchedTask = await getDBEntry("task", {
            _id: taskId,
        })
        task = fetchedTask
        manualTask = JSON.parse(JSON.stringify(task))
    }

    loadData()

    function handleBack() {
        spaNavigate(`/order/${orderId}/task/${taskId}`)
    }
</script>

<section class="manual-protocol-page wrapper">
    {#if manualTask}
        <ManualProtocol
            standalone="{true}"
            task="{manualTask}"
            onBack="{handleBack}"
            on:updateTaskProtocol="{(event) => {
                task.manualProtocol = event.detail
                manualTask = {
                    ...manualTask,
                    manualProtocol: JSON.parse(JSON.stringify(event.detail)),
                }
            }}"
        />
    {:else}
        <Loader />
    {/if}
</section>

<style lang="less">
    @import "../../assets/variables.less";
    .manual-protocol-page {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 2.4rem 0;
    }
</style>
